/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export function emptyFunction () :void {}

export default emptyFunction;

